import { SRFBridge } from 'srf-native-bridge';
import { getConfig } from '@fec/assets/js/utils/config.js';

const config = getConfig();

export const shouldHandleWidgetLinks = () =>
  SRFBridge.isRunningInApp() && config.CLICKJACKING_ENABLED;

export const handleWidgetLinks = (event) => {
  // problem: link-click is also triggered on elements inside of <a> --> we
  // need to check the whole path from [0] to #react-root (top of shadow
  // dom) and if there's an <a> in there, prevent it and send the event to
  // the nativeBridge
  const path = event.composedPath();
  const rootIndex = path.findIndex((obj) => obj.matches('#react-root'));
  const relevantPath = path.slice(0, rootIndex);
  const linkInRelevantPath = relevantPath.find((obj) => obj.matches('a'));

  if (linkInRelevantPath) {
    const url = linkInRelevantPath.href;
    if (!url) {
      return;
    }
    event.preventDefault();
    SRFBridge.openLink(url);
  }
};

// links are defined in a 3rd party tool, and we don't know the target at build
// time, so we need to catch these events and send them to the native bridge.
export function init() {
  if (shouldHandleWidgetLinks()) {
    document
      .querySelectorAll('.js-srg-election-widget')
      .forEach((widget) =>
        widget.addEventListener('click', (e) => handleWidgetLinks(e)),
      );
  }
}
